import { render, staticRenderFns } from "./TestingSelectComponent.vue?vue&type=template&id=34692f55&scoped=true"
import script from "./TestingSelectComponent.vue?vue&type=script&lang=js"
export * from "./TestingSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34692f55",
  null
  
)

export default component.exports